import Style from "./DesktopHeader.module.css";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { FaSortDown } from "react-icons/fa6";


export default function NavbarItemDesktop({
    label = "",
    path = '/',
    sublists = [],
    isActive = false,
}) {
    return <div className={[Style.nabarItemParentLinks]} >
        <NavLink
            to={path}
            className={
                isActive
                    ? `${[Style.nabarLinks, Style.navActive].join(" ")}`
                    : `${[Style.nabarLinks]}`
            }
        >
            <span>
                {label}
            </span>
            {
                sublists.length ?
                    <FaSortDown /> : ''
            }
        </NavLink>

        {
            sublists.length ?
                <div className={[Style.nabarSubMenu]}>
                    {
                        sublists.map((item, index) =>
                            <NavbarItemDesktop key={`subitem-${index}`} {...item} />
                        )
                    }
                </div>
                : ""
        }
    </div >
}